import { userHasEditorAccess } from "@utils/projectAccess";
import * as RouteHelper from "@utils/paths";
import { PackageType } from "catchment-common/entities/contractorPackage";
import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { OrganisationLineItem } from "catchment-common/interfaces/organisation";
import { ProjectLineItem } from "catchment-common/interfaces/project";
import { NavItemType } from "types";

import { safeUrl } from "./menuItemUrl";
import Icon from "@ui/atoms/Icon/Icon";

export const getManageNav = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem,
  organisation?: OrganisationLineItem
): NavItemType => {
  const children = [];

  if (
    contractorPackage?.packageType === PackageType.HeadContractorPackage ||
    organisation?.subpackageEnabled
  ) {
    const showSubPackages =
      contractorPackage?.packageType !== PackageType.HeadContractorPackage &&
      organisation?.subpackageEnabled;
    children.push({
      icon: <Icon name="packages" />,
      id: "packages",
      title: showSubPackages ? "Subpackages" : "Work Packages",
      type: "item",
      url: safeUrl(project, contractorPackage, () =>
        RouteHelper.packages(project!.id, contractorPackage!.id)
      )
    });
  }

  if (userHasEditorAccess(project)) {
    children.push({
      icon: <Icon name="users" />,
      id: "project-employees",
      title: "Project Workforce",
      type: "item",
      url: safeUrl(project, contractorPackage, () =>
        RouteHelper.projectEmployees(project!.id, contractorPackage!.id)
      )
    });
  }

  // The head contractor forecasts the whole project — its own package's months
  // are one row's drill-down inside that page. Everyone else forecasts only
  // their own package, so they land straight on it.
  if (userHasEditorAccess(project)) {
    children.push({
      icon: <Icon name="trending-up" />,
      id: "forecast",
      title: "Forecasting",
      type: "item",
      url: safeUrl(project, contractorPackage, () =>
        contractorPackage!.packageType === PackageType.HeadContractorPackage
          ? RouteHelper.forecastProjectLevel1(project!.id)
          : RouteHelper.forecast(project!.id, contractorPackage!.id)
      )
    });
  }

  return {
    children,
    id: "manage",
    title: "Manage",
    type: "group"
  };
};
